import { Component, ViewChild } from '@angular/core';
import { Platform, Nav, Events, IonicApp, AlertController } from 'ionic-angular';
import { ApiProvider } from '../providers/api/api';
import { AnalyticsProvider } from '../providers/analytics/analytics';
import { CommonProvider } from '../providers/common/common';
import { Storage } from '@ionic/storage';
import { FirebaseMessagingProvider } from '../providers/firebase-messaging/firebase-messaging';
import { DatePipe } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';
declare var SERVICE_ID;
declare var API_ENDPOINT;
declare let window: any;
//declare let app_uid_val;
declare let google;
declare let gtag: Function;

@Component({
  templateUrl: 'app.html',
  providers: [DatePipe]
})
export class MyApp {
  rootPage:any;
  //rootPage:any = 'home';
  @ViewChild(Nav) nav: Nav;
  menu_header = {background_color:'',image:'',title:''};

  is_pc:boolean;
  service_data = [];
  user_data = [];
  is_login:boolean = false;
  uid:string;
  drawer_list = [];
  is_app:boolean;
  is_pwa_account:boolean = false;
  url;
  params;
  app_version;
  button_color = '#ffffff';
  button_background = '#4e8ef7';
  current_page:string;
  rootParams = [];
  chk_start = {chk_home:false,chk_slide:false,chk_token:false,chk_rss:false,chk_drawer:false};
  chk_pc = {chk_drawer:false,chk_push:false,chk_event:false,chk_coupon:false,chk_menu:false};
  app_uid;
  app_token;
  app_user_authenticate;
  add_langs = ['ja', 'en'];

  constructor(
    public platform: Platform,
    public events: Events,
    public ionicApp: IonicApp,
    public apiProv: ApiProvider,
    public gaProv: AnalyticsProvider,
    public comProv: CommonProvider,
    public storage: Storage,
    public fcmProv: FirebaseMessagingProvider,
    public alertCtrl: AlertController,
    public translate: TranslateService,
  ) {
    if (location.hash == '#/home') {
      this.comProv.restart();
    }
    platform.ready().then(() => {
      this.is_pc = this.comProv.isPc();
      this.setupBackButtonBehavior();
    });

    this.url = new URL(window.location.href);
    this.params = this.url.searchParams;
    if (this.params.get('back') == 1) {
      let user_agent = window.navigator.userAgent;
      if (user_agent.indexOf('tenpoapp ServiceId') != -1) {
        let back_url = window.location.href;
        back_url = back_url.replace(/back=1/g, 'back=2');
        this.comProv.closeWebview(back_url);
        return;
      }
    }

    // プレビュー表示
    if (this.params.get('page') == 'PreviewPage') {
      this.comProv.setOptions('is_preview', 1);
      this.comProv.restart();
    }

    // 多言語設定
    this.translate.setDefaultLang('ja');
    this.translate.addLangs(this.add_langs);

    this.rootParams['is_top_tab_list'] = false;
    let app_version = this.params.get('app_version');
    if (app_version) {
      this.comProv.getAppUid();
      this.comProv.getAppToken();
      this.comProv.getAppUser();

      localStorage.setItem('is_app', '1');
      localStorage.setItem('app_version', app_version);
      this.app_version = app_version;
    }
    this.is_app = this.comProv.isApp();

    if (this.params.get('page') == 'MemberSafePage' || location.hash == '#/member-safe') {
      this.rootPage = 'MemberSafePage';
      return;
    }

    try {
      google;
    } catch(e) {
      this.setGoogleMap();
    }
    this.getService();

    events.subscribe('login:set', () => {
      this.is_login = this.comProv.isLogin();
    });

    window.appUid = function(uid) {
      this.app_uid = uid;
    }.bind(this)
    window.appToken = function(token) {
      this.app_token = token;
    }.bind(this)
    window.appUserAuthenticates = function(user_authenticate) {
      this.app_user_authenticate = decodeURIComponent(user_authenticate);
    }.bind(this)
    window.appQRCodeReader2 = function(value) {
      this.goQRCodeUrl(value);
    }.bind(this)
    window.appMemberCode = function(member_code){
      let user_data = this.comProv.getUser();
      user_data['member_code'] = member_code;
      this.comProv.setUser(user_data);
    }.bind(this)
    window.appPoint = function(point) {
      let point_data = {};
      point_data['point']    = point;
      point_data['get_time'] = this.comProv.formatDate(new Date(), 'YYYY/MM/DD hh:mm:ss');
      localStorage.setItem('point_data', JSON.stringify(point_data));
      this.events.publish('point_data');
    }.bind(this)
  }

  ngAfterViewInit() {
    this.nav.viewDidLoad.subscribe((view) => {
    //this.nav.viewDidEnter.subscribe((view) => {
      this.current_page = view.instance.constructor.name;
      this.rootParams['current_page'] = view.instance.constructor.name;
      if (
        this.current_page == 'ErrorPage' || 
        this.current_page == 'PrivacyPage' || 
        this.current_page == 'SharePage' || 
        this.current_page == 'MemberSafePage'
      ) {
        return;
      }

      this.checkPlatform();
    });
  }

  setupBackButtonBehavior() {
    if (window.location.protocol !== "file:") {
      window.onpopstate = (evt) => {
        let activePortal = this.ionicApp._loadingPortal.getActive() ||
          this.ionicApp._modalPortal.getActive() ||
          this.ionicApp._toastPortal.getActive() ||
          this.ionicApp._overlayPortal.getActive();
        if (activePortal) {
          try {
            activePortal.dismiss();
          } catch(e) {
            console.log(e);
          }
          return;
        }
      };
    }
  }

  setGoogleMap() {
    let googlemap_key = 'AIzaSyDg9cLhXb7UBK6tFw7d-2Lqib-59X1ZtQQ';
    let key_list = [
      {name:'S1-100',   min:1,   max:100, keys:['AIzaSyDg9cLhXb7UBK6tFw7d-2Lqib-59X1ZtQQ']},
      {name:'S101-300', min:101, max:300, keys:['AIzaSyBIW5X1dsWtTu0DfDmbuo_NskQGcAjxE7k']},
      {name:'S301-400', min:301, max:400, keys:['AIzaSyD3P1N2leLpKupDQKOJvyTVFF6svipQIi8']},
      {name:'S401-500', min:401, max:500, keys:['AIzaSyClNMVhSEolNKOJV4goFx3qa0jjvATOVIA']},
      {name:'S501-600', min:501, max:600, keys:['AIzaSyDMChpm09JGD2zrMD4yIcTVmGTAILAGLvc']}
    ];

    let find_data = key_list.find((value) => {
      return (SERVICE_ID >= value['min'] && SERVICE_ID <= value['max']);
    });
    if (find_data) {
      if (find_data['keys'].length > 1) {
        googlemap_key = find_data['keys'][Math.floor(Math.random() * find_data['keys'].length)];
      } else {
        googlemap_key = find_data['keys'][0];
      }
    }
    //console.log('googlemap_key', googlemap_key);

    let script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = 'https://maps.google.com/maps/api/js?key=' + googlemap_key;
    document.body.appendChild(script);
  }

  getService() {
    let url_req;
    if (this.url['hostname'] == 'localhost') {
      url_req = API_ENDPOINT + '/api/services/' + SERVICE_ID;
    } else {
      //url_req = API_ENDPOINT + '/api/services/' + SERVICE_ID;
      url_req = '/api/services/' + SERVICE_ID;
    }

    this.apiProv.dispLoader();
    this.apiProv.get(url_req)
    .then(data => {
      if (data['statusCode'] != '000') {
        this.apiProv.removeLoader();
        this.goError('通信環境の良い場所で再度起動してください。');
        return;
      } else {
        this.service_data = data['data'];
        localStorage.setItem('service_data', JSON.stringify(this.service_data));
        this.is_pwa_account = this.comProv.isPwaAccount();
        this.fcmProv.start();

        // 多言語設定
        if (this.service_data['option']['is_multilingual']) {
          let browser_lang = this.translate.getBrowserLang();
          if (this.add_langs.indexOf(browser_lang) >= 0) {
            this.translate.use(browser_lang);
          }
        }

        if (this.service_data['status'] != 1) {
          this.apiProv.removeLoader();
          this.goError('現在サービスはご利用できません。');
          return;
        }

        if (location.hash == '#/share' || location.hash == '#/privacy') {
          this.apiProv.removeLoader();
          this.getHome();
          return;
        }
        this.checkPlatform();

        if (!this.is_app && this.url['hostname'] != 'localhost') {
          if (this.service_data['pwa_url'].indexOf(this.url['host']) == -1) {
            // 独自ドメインにリダイレクト
            window.location.href = this.service_data['pwa_url'];
          }
        }

        if (this.service_data['ga4_tracking_id']) {
          try {
            gtag('config', this.service_data['ga4_tracking_id']);
          } catch(e) {
            console.log(e);
          }
          this.nav.viewDidEnter.subscribe(
            (view) => {
              this.gaProv.trackViewGA4(view.id);
            }
          );
        }

        // トップページ
        this.getHome();
        this.getDrawer();
        this.getSlide();
        if (this.comProv.isPc()) {
          this.getPush();
          this.getEvent();
          this.getCoupon();
          this.getMenuAll();
          this.chk_start['chk_rss'] = true;
        }

        // 共通部品取得
        this.getPhotoCategory();
        this.getCouponCategory();
        this.getShopInfo();
        /*if (this.service_data['is_app_membership_card']) {
          this.getCardData();
        }*/
        if (!this.comProv.isPc()) {
          this.getWebviewData();
          this.getProfileList();
          if (this.service_data['option']['is_rss_feed']) {
            this.getRssList();
          } else {
            this.chk_start['chk_rss'] = true;
          }
        }

        if (this.service_data['font']) {
          let font = this.service_data['font'];
          let style = document.createElement('style');
          style.textContent = "@font-face {font-family:'" + font + "';}ion-content{font-family:'" + font + "';}ion-header{font-family:'" + font + "';}ion-footer{font-family:'" + font + "';}";
          document.head.appendChild(style);
        }

        // ユーザー取得
        this.getUid();
      }
    }).catch(error => {
      this.apiProv.removeLoader();
      let message = this.apiProv.getErrorMessage(error, '通信環境の良い場所で再度起動してください。');
      this.goError(message);
    });
  }

  checkPlatform() {
    let service_data = this.comProv.getService();
    if (this.is_app) {
      if (this.platform.is('ios')) {
        if (service_data['is_ios_app'] != 1) {
          this.goError('現在iOSアプリはご利用できません。');
        }
      }
      if (this.platform.is('android')) {
        if (service_data['is_android_app'] != 1) {
          this.goError('現在アンドロイドアプリはご利用できません。');
        }
      }
    } else {
      if (this.comProv.isPc()) {
        if (service_data['is_pc'] != 1) {
          this.goError('現在PCはご利用できません。');
        }
      } else {
        if (service_data['is_pwa'] != 1) {
          this.goError('現在PWAはご利用できません。');
        }
      }
    }
  }

  getHome() {
    this.apiProv.get(this.service_data['_links']['app_top_menu']['href'])
    .then(data => {
      if (data['statusCode'] != '000') {
        this.goError('トップメニューの設定を行ってください。');
        return;
      }

      // プレビュー表示
      if (this.comProv.getOptionsValue('is_preview')) {
        if (!data['data']['preview_body']) {
          this.comProv.setOptions('is_preview', 0);
          this.goError('プレビュー表示設定がありません。');
          return;
        }

        data['data']['base'] = data['data']['preview_base'];
        data['data']['header'] = data['data']['preview_header'];
        data['data']['body'] = data['data']['preview_body'];
        data['data']['footer'] = data['data']['preview_footer'];
      }

      this.comProv.setHomeImage(data['data']['body']);
      localStorage.setItem('header_data', JSON.stringify(data['data']['header']));
      this.setFooter(data['data']['footer']);
      localStorage.setItem('pc_data', JSON.stringify(data['data']['pc']));
      localStorage.setItem('words_data', JSON.stringify(data['data']['words']));

      let base_data = data['data']['base'];
      localStorage.setItem('base_data', JSON.stringify(base_data));
      if (base_data['button_color']) {
        this.button_color = base_data['button_color'];
      }
      if (base_data['button_background_color']) {
        this.button_background = base_data['button_background_color'];
      }

      this.setMenuHeader(data['data']['header']);

      if (location.hash == '#/share' || location.hash == '#/privacy') {
        this.events.publish('share:start');
      } else {
        this.chk_start['chk_home'] = true;
        this.goHome();
      }
    }).catch(error => {
      let message = this.apiProv.getErrorMessage(error, 'トップメニューの設定を行ってください。');
      this.goError(message);
    });
  }

  setFooter(footer_data) {
    if (!footer_data || footer_data == '') {
      return;
    }

    let set = [];
    for (let i=1; i<=5; i++) {
      let line = {
        icon: footer_data['tab_icon' + i],
        text: footer_data['tab_text' + i],
        target: footer_data['tab_target' + i],
        url: footer_data['tab_url' + i]
      };
      if (!line['icon'] || !line['text'] || !line['target']) {
        continue;
      }
      set.push(line);
    }
    localStorage.setItem('footer_list', JSON.stringify(set));
    localStorage.setItem('footer_color', footer_data['color']);
    localStorage.setItem('footer_inactive_color', footer_data['inactive_color'] ? footer_data['inactive_color'] : '#b3b3b3');
    localStorage.setItem('footer_background_color', footer_data['background_color']);
  }

  setMenuHeader(header_data) {
    this.menu_header['title'] = this.service_data['name'];
    if (header_data && header_data != '') {
      this.menu_header['background_color'] = header_data['background_color'];
      this.menu_header['image'] = header_data['image'];
    }
  }

  getSlide() {
    this.apiProv.get(this.service_data['_links']['app_top_slide_images']['href'])
    .then(data => {
      if (data['statusCode'] != '000') {
        return;
      }
      this.rootParams['slide_list'] = data['data'];

      this.chk_start['chk_slide'] = true;
      this.goHome();
    }).catch(error => {
    });
  }

  getPush() {
    this.apiProv.get(this.service_data['_links']['notifications']['href'])
    .then(data => {
      if (data['statusCode'] != '000') {
        return;
      }
      this.rootParams['push_list'] = data['data'];

      this.chk_pc['chk_push'] = true;
      this.goHomePc();
    }).catch(error => {
      this.chk_pc['chk_push'] = true;
      this.goHomePc();
    });
  }

  getEvent() {
    this.apiProv.get(this.service_data['_links']['events']['href'])
    .then(data => {
      if (data['statusCode'] != '000') {
        return;
      }
      this.rootParams['event_list'] = data['data'];

      this.chk_pc['chk_event'] = true;
      this.goHomePc();
    }).catch(error => {
      this.chk_pc['chk_event'] = true;
      this.goHomePc();
    });
  }

  getCoupon() {
    this.apiProv.get(this.service_data['_links']['coupons']['href'])
    .then(data => {
      if (data['statusCode'] != '000') {
        return;
      }
      localStorage.setItem('coupon_list', JSON.stringify(data['data']));
      this.rootParams['coupon_list'] = data['data'];

      this.chk_pc['chk_coupon'] = true;
      this.goHomePc();
    }).catch(error => {
      this.chk_pc['chk_coupon'] = true;
      this.goHomePc();
    });
  }

  getMenuAll() {
    this.apiProv.get(this.service_data['_links']['menu_all']['href'])
    .then(data => {
      if (data['statusCode'] != '000') {
        return;
      }
      this.rootParams['menu_all'] = data['data'];

      this.chk_pc['chk_menu'] = true;
      this.goHomePc();
    }).catch(error => {
      this.chk_pc['chk_menu'] = true;
      this.goHomePc();
    });
  }

  goHome() {
    if (!this.chk_start['chk_home'] || !this.chk_start['chk_slide'] || !this.chk_start['chk_token'] || !this.chk_start['chk_rss'] || !this.chk_start['chk_drawer']) {
      return;
    }
    this.apiProv.removeLoader();
    this.rootParams['is_start'] = true;

    let top_flg = this.comProv.checkTop();
    if (!this.uid || this.comProv.isPc()) {
      top_flg = false;
    }
    
    if (top_flg) {
      if (this.comProv.isTutorial()) {
        this.rootPage = 'TopTutorialPage';
      } else {
        this.rootPage = 'TopRulePage';
      }
    } else {
      if (!location.hash) {
        let page = this.params.get('page');
        if (page) {
          if (page == 'CouponIndexPage' && this.params.get('target')) {
            this.comProv.setOptions('private_coupon_target', this.params.get('target'));
            history.replaceState('','','/');
          }

          this.rootPage = page;
        } else {
          this.rootPage = 'home';
        }
      } else if (location.hash == '#/home') {
        this.rootPage = 'home';
      }
    }
  }

  goHomePc() {
    if (!this.chk_pc['chk_drawer'] || !this.chk_pc['chk_push'] || !this.chk_pc['chk_event'] || !this.chk_pc['chk_coupon'] || !this.chk_pc['chk_menu']) {
      return;
    }
    this.rootParams['is_pc_start'] = true;
    this.events.publish('home:pc');
  }

  getUid() {
    if (this.comProv.isPc()) {
      this.chk_start['chk_token'] = true;
      this.goHome();
      return;
    }

    if (this.is_app) {
      if (!this.app_uid || this.app_uid == '' || this.app_uid == 'null') {
        new Image().src = '?app_log=notUid1';
        // 2秒遅延
        this.comProv.getAppUid();
        setTimeout(() => {
          if (!this.app_uid || this.app_uid == '' || this.app_uid == 'null') {
            new Image().src = '?app_log=notUid2';
            this.goError('UIDが取得できません。');
            return;
          }
          this.uid = this.app_uid;
          //this.uid = app_uid_val;
          this.getAppToken();
          //this.getToken();
        }, 2000)
      } else {
        this.uid = this.app_uid;
        //this.uid = app_uid_val;
        this.getAppToken();
        //this.getToken();
      }
    } else {
      this.storage.get('uid').then((val) => {
        if (!val || val == '' || val == 'null') {
          this.chk_start['chk_token'] = true;
          this.goHome();
          return;
        }
        this.uid = val;
        this.getToken();
      });
    }
  }

  getAppToken() {
    // アプリからデータが取得できない場合
    if (!this.app_token || !this.app_user_authenticate) {
      new Image().src = '?getLocalToken=ng&code=NotGetFromApp&time=' + new Date().getTime();
      this.getToken();
      return;
    }

    if (this.comProv.isAndroid()) {
      let app_version = this.comProv.getAppVersion();
      if (app_version && app_version < 1.21) {
        new Image().src = '?getLocalToken=ng&code=NotAndroidVersion&app_version=' + app_version + '&time=' + + new Date().getTime();
        this.getToken();
        return;
      }
    }

    let local_token = localStorage.getItem('token');;
    let local_user_data = this.comProv.getUser();
    let tmp_app_user = JSON.parse(this.app_user_authenticate);
    let app_user_data = tmp_app_user['data'];

    let use_local_data = false;
    if (local_token && local_user_data['id'] && local_user_data['id'] != 'undefined') {
      // ローカルの方が新しい
      let chk_token_time = this.comProv.checkTime(app_user_data['accessed_at'], local_user_data['accessed_at']);
      if (chk_token_time) {
        use_local_data = true;
      }
    }

    if (use_local_data) {
      new Image().src = '?getLocalToken=ok&data=local&local_accessed_at=' + local_user_data['accessed_at'] + '&app_accessed_at=' + app_user_data['accessed_at'] + '&time=' + new Date().getTime();
      this.user_data = local_user_data;
    } else {
      new Image().src = '?getLocalToken=ok&data=app&local_accessed_at=' + local_user_data['accessed_at'] + '&app_accessed_at=' + app_user_data['accessed_at'] + '&time=' + new Date().getTime();
      this.user_data = app_user_data;
      this.comProv.setUser(this.user_data);
      this.storage.set('uid', this.user_data['uid']);
      localStorage.setItem('token', this.app_token);
    }
    this.is_login = this.comProv.isLogin();

    this.setFcmToken();

    this.chk_start['chk_token'] = true;
    this.goHome();
  }

  getToken() {
    console.log('getToken app.component.ts');
    let user_env = [];
    user_env['uid'] = this.uid;
    this.comProv.setUserEnv(user_env);
    this.apiProv.post(this.service_data['_links']['user_authenticate']['href'],user_env)
    .then(data => {
      if (data['statusCode'] != '000') {
        if (this.is_app) {
          this.goError('アプリのUIDが正しくありません。');
        }  else {
          this.goError('該当ユーザが見つかりません。');
        }
      } else {
        this.user_data = data['data'];

        this.comProv.setUser(this.user_data);
        this.storage.set('uid', this.user_data['uid']);
        localStorage.setItem('token', data['token']);
        this.is_login = this.comProv.isLogin();
        
        this.setFcmToken();

        this.chk_start['chk_token'] = true;
        this.goHome();
      }
    }).catch(error => {
      console.log('user_authenticate', error);
      if (this.is_app) {
        let message = this.apiProv.getErrorMessage(error, 'アプリのUIDが正しくありません。');
        this.goError(message);
      } else {
        if (error['status'] == 404) {
          this.comProv.logout();
        }
        let message = this.apiProv.getErrorMessage(error, '該当ユーザが見つかりません。');
        this.goError(message);
      }
    });
  }

  setFcmToken() {
    if (this.is_app) {
      return;
    }
    
    this.storage.get('fcm_token').then((val) => {     
      if (!val || val == this.user_data['fcm_token']) {
        return;
      }
        
      let url = this.service_data['_links']['user_update']['href'];
      let url_req = url.replace('##user_id##', this.user_data['id']);

      let params = {fcm_token:val};
      this.apiProv.patch(url_req, params)
      .then(data => {
        if (data['statusCode'] != '000') {
          return;
        }

        // 保持データ更新
        this.user_data['fcm_token'] = val;
        this.comProv.setUser(this.user_data);
      }).catch(error => {
        console.log('error', error);
      });
    });
  }

  getDrawer() {
    this.apiProv.get(this.service_data['_links']['app_drawer_menus']['href'])
    .then(data => {
      if (data['statusCode'] != '000') {
        return;
      }
      for (let i=0; i<data['data'].length; i++) {
        if (data['data'][i]['is_privated'] == 1) {
          continue;
        }
        if (data['data'][i]['image_url']) {
          data['data'][i]['image_url'] = data['data'][i]['image_url'].replace('fab ', 'fab-tenpo ');
        }
        this.drawer_list.push(data['data'][i]);
      }
      
      localStorage.setItem('drawer_list', JSON.stringify(data['data']));
      this.events.publish('drawer:set');
      if (this.comProv.isPc()) {
        this.chk_pc['chk_drawer'] = true;
        this.goHomePc();
      }
      this.chk_start['chk_drawer'] = true;
      this.goHome();
    }).catch(error => {
      if (this.comProv.isPc()) {
        this.chk_pc['chk_drawer'] = true;
        this.goHomePc();
      }
      this.chk_start['chk_drawer'] = true;
      this.goHome();
    });
  }

  getPhotoCategory() {
    this.apiProv.get(this.service_data['_links']['photo_categories']['href'])
    .then(data => {
      if (data['statusCode'] != '000') {
        return;
      }
      localStorage.setItem('photo_category', JSON.stringify(data['data']));
    }).catch(error => {
    });
  }

  getCouponCategory() {
    this.apiProv.get(this.service_data['_links']['coupon_categories']['href'])
    .then(data => {
      if (data['statusCode'] != '000') {
        return;
      }
      localStorage.setItem('coupon_category_list', JSON.stringify(data['data']));
    }).catch(error => {
    });
  }

  getShopInfo() {
    this.apiProv.get(this.service_data['_links']['shop_info']['href'])
    .then(data => {
      if (data['statusCode'] != '000') {
        return;
      }
      localStorage.setItem('brand_list', JSON.stringify(data['data']['brands']));
      localStorage.setItem('prefecture_list', JSON.stringify(data['data']['prefecture']));
    }).catch(error => {
    });
  }

  getCardData() {
    this.apiProv.get(this.service_data['_links']['app_membership_card']['href'])
    .then(data => {
      if (data['statusCode'] != '000') {
        this.apiProv.detaError(data);
        return;
      }
      localStorage.setItem('card_data', JSON.stringify(data['data']));
    }).catch(error => {
    });
  }

  getWebviewData() {
    this.apiProv.get(this.service_data['_links']['app_webviews']['href'])
    .then(data => {
      if (data['statusCode'] != '000') {
        this.apiProv.detaError(data);
        return;
      }
      localStorage.setItem('webview_data', JSON.stringify(data['data']));
    }).catch(error => {
    });
  }

  getProfileList() {
    this.apiProv.get(this.service_data['_links']['target_user_profiles']['href'])
    .then(data => {
      if (data['statusCode'] != '000') {
        this.apiProv.detaError(data);
        return;
      }
      localStorage.setItem('profile_list', JSON.stringify(data['data']));
    }).catch(error => {
    });
  }

  getRssList() {
    this.apiProv.get(this.service_data['_links']['rss_feeds']['href'])
    .then(data => {
      if (data['statusCode'] != '000') {
        this.apiProv.detaError(data);
        return;
      }
      localStorage.setItem('rss_list', JSON.stringify(data['data']));
      this.chk_start['chk_rss'] = true;
      this.goHome();
    }).catch(error => {
    });
  }

  goQRCodeUrl(barcode_text) {
    let chk = barcode_text.match(/(http|https):\/\/.+/);
    if (!chk) {
      let alert = this.alertCtrl.create({
        message: '値がURLではありません。',
        cssClass: 'alert_common',
        enableBackdropDismiss:false,
        buttons: [
          {
            text: '閉じる',
            role: 'cancel',
            handler: () => {
            }
          },
        ]
      });
      alert.present();
      return;
    }

    this.comProv.setLink(barcode_text);
  }

  goPage(page_data) {
    let data = {
      url: page_data['page_url'],
      target: page_data['page_target'],
      current_page: this.rootParams['current_page'],
      //current_page: this.current_page,
      category: 'ドロワーメニュー'
    };
    this.comProv.goPage(data, this.nav, this.gaProv);
  }

  setPage(page_name) {
    this.nav.setRoot(page_name);
  }

  goStore() {
    if (this.platform.is('android')) {
      window.ionic.postReview();
    } else if (this.platform.is('ios') && this.service_data['apple_id']) {
      var message = {
        action: 'Review',
        parameters: {
          app_id: this.service_data['apple_id']
        }
      };
      window.webkit.messageHandlers.ionic.postMessage(message);
    }
  }

  goError(message) {
    this.nav.setRoot('ErrorPage',{message:message});
  }

  logout() {
    this.comProv.logout();
    this.is_login = this.comProv.isLogin();

    this.nav.setRoot('LoginPage');
  }

  login() {
    this.nav.setRoot('LoginPage');
  }
}


// WEBPACK FOOTER //
// ./src/app/app.component.ts